(function () {
  'use strict';

  function getPanelTabId(panel) {
    return panel.getAttribute('data-s20-tab-panel');
  }

  function initSubscribe20(root) {
    if (!root) return;

    var tabnav = root.querySelector('#s20-tabnav');
    var tabnavInner = tabnav ? tabnav.querySelector('.tabnav-inner') : null;
    var tabs = root.querySelectorAll('.tab-btn[data-tab]');
    var panels = root.querySelectorAll('[data-s20-tab-panel]');
    var gotoLinks = root.querySelectorAll('[data-goto]');

    var scrollLock = false;
    var scrollLockTimer;
    var currentActiveTab = null;
    var VIEWPORT_BOTTOM_OFFSET = 400;

    function navOffset() {
      return tabnav ? tabnav.offsetHeight + 0 : 12;
    }

    function firstPanelForTab(tabId) {
      for (var i = 0; i < panels.length; i++) {
        if (getPanelTabId(panels[i]) === tabId) return panels[i];
      }
      return null;
    }

    function scrollToTab(tabId) {
      var target = firstPanelForTab(tabId);
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - navOffset();
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function beginScrollLock() {
      scrollLock = true;
      clearTimeout(scrollLockTimer);
      scrollLockTimer = setTimeout(function () {
        scrollLock = false;
      }, 1000);
    }

    function ensureActiveTabVisible(smooth) {
      if (!tabnavInner) return;
      var activeBtn = root.querySelector('.tab-btn.is-active');
      if (!activeBtn) return;

      var innerRect = tabnavInner.getBoundingClientRect();
      var btnRect = activeBtn.getBoundingClientRect();
      var padding = 12;

      if (btnRect.left >= innerRect.left + padding && btnRect.right <= innerRect.right - padding) {
        return;
      }

      var nextScrollLeft = tabnavInner.scrollLeft;
      if (btnRect.left < innerRect.left + padding) {
        nextScrollLeft += btnRect.left - innerRect.left - padding;
      } else if (btnRect.right > innerRect.right - padding) {
        nextScrollLeft += btnRect.right - innerRect.right + padding;
      }

      tabnavInner.scrollTo({
        left: Math.max(0, nextScrollLeft),
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    function setActiveTabVisual(tabId, smoothTabNav) {
      if (!tabId || tabId === currentActiveTab) return;
      currentActiveTab = tabId;

      tabs.forEach(function (btn) {
        var active = btn.dataset.tab === tabId;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      ensureActiveTabVisible(!!smoothTabNav);
    }

    function tabFromScroll() {
      if (!tabs.length) return null;

      var topLine = navOffset();
      var bottomLine = window.innerHeight - VIEWPORT_BOTTOM_OFFSET;
      var bestTab = tabs[0].dataset.tab;
      var bestVisible = 0;

      tabs.forEach(function (btn) {
        var tabId = btn.dataset.tab;
        if (!tabId) return;

        var tabPanels = root.querySelectorAll('[data-s20-tab-panel="' + tabId + '"]');
        var visibleHeight = 0;

        for (var j = 0; j < tabPanels.length; j++) {
          var rect = tabPanels[j].getBoundingClientRect();
          var visibleTop = Math.max(rect.top, topLine);
          var visibleBottom = Math.min(rect.bottom, bottomLine);
          if (visibleBottom > visibleTop) {
            visibleHeight += visibleBottom - visibleTop;
          }
        }

        if (visibleHeight > bestVisible) {
          bestVisible = visibleHeight;
          bestTab = tabId;
        }
      });

      return bestTab;
    }

    function syncActiveTabFromScroll() {
      if (scrollLock || !tabs.length) return;
      var tabId = tabFromScroll();
      if (tabId) setActiveTabVisual(tabId, false);
    }

    function activateTab(tabId, shouldScroll) {
      if (!tabId) return;
      if (tabId !== currentActiveTab) {
        setActiveTabVisual(tabId, true);
      } else {
        ensureActiveTabVisible(true);
      }
      if (shouldScroll !== false) {
        beginScrollLock();
        scrollToTab(tabId);
      }
    }

    if (!root.dataset.s20Init) {
      root.dataset.s20Init = 'true';

      var scrollTicking = false;
      function onScroll() {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          syncActiveTabFromScroll();
          scrollTicking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        syncActiveTabFromScroll();
        ensureActiveTabVisible(false);
      });

      tabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateTab(btn.dataset.tab, true);
        });
      });

      gotoLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = link.dataset.goto;
          if (!target) return;
          if (link.getAttribute('href') === '#') e.preventDefault();

          beginScrollLock();
          setActiveTabVisual(target, true);

          var hashTarget = link.getAttribute('href');
          if (hashTarget && hashTarget.charAt(0) === '#' && hashTarget.length > 1) {
            var el = root.querySelector(hashTarget);
            if (el) {
              requestAnimationFrame(function () {
                var top = el.getBoundingClientRect().top + window.pageYOffset - navOffset();
                window.scrollTo({ top: top, behavior: 'smooth' });
              });
              return;
            }
          }

          scrollToTab(target);
        });
      });

      root.querySelectorAll('.mslider').forEach(function (mslider) {
        if (mslider.dataset.s20SliderInit === 'true') return;
        mslider.dataset.s20SliderInit = 'true';

        var msTrack = mslider.querySelector('.mslider-track');
        var msPrev = mslider.querySelector('.ms-prev');
        var msNext = mslider.querySelector('.ms-next');
        if (!msTrack || !msPrev || !msNext) return;

        var step = function () {
          var card = msTrack.querySelector('.mission-card');
          return card ? card.offsetWidth + 18 : 320;
        };
        msPrev.addEventListener('click', function () {
          msTrack.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        msNext.addEventListener('click', function () {
          msTrack.scrollBy({ left: step(), behavior: 'smooth' });
        });
      });
    }

    var tiers = root.querySelector('.tiers');
    var featured = root.querySelector('.tier-card.featured');
    if (tiers && featured) {
      var ribbon = featured.querySelector('.ribbon');
      if (ribbon) {
        tiers.style.setProperty('--pp-banner-h', ribbon.offsetHeight + 'px');
      }
    }

    var initial = root.querySelector('.tab-btn.is-active');
    var tabFromHash = window.location.hash.replace('#', '');
    var validTabs = ['subscribe', 'benefits', 'whatsinbox', 'vetting', 'faq'];

    if (validTabs.indexOf(tabFromHash) !== -1) {
      activateTab(tabFromHash, true);
    } else if (initial) {
      currentActiveTab = null;
      setActiveTabVisual(initial.dataset.tab, false);
    } else if (tabs.length) {
      currentActiveTab = null;
      setActiveTabVisual(tabs[0].dataset.tab, false);
    }

    syncActiveTabFromScroll();
    ensureActiveTabVisible(false);
  }

  function boot() {
    document.querySelectorAll('.subscribe-2-0').forEach(initSubscribe20);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    var root = document.querySelector('#subscribe-2-0.subscribe-2-0');
    if (root) initSubscribe20(root);
  });
})();
